<div class="container">
  @let offer = challenge();
  @let reward = config().rewardContainer;
  @let spendGoal = offer.type === OfferType.STEP ? offer.maxTarget : null;
  @if (offer.type === OfferType.FREQUENCY) {
    <p
      class="minimum-spend-label"
      [style.color]="config().minimumSpendLabel.color"
      [style.fontFamily]="config().minimumSpendLabel.fontFamily"
      [innerHTML]="
        config().minimumSpendLabel.text
          | replaceVars: offer.minAmountByTransaction
          | safe
      "
    ></p>
  }

  <div
    class="label-container"
    [style.backgroundColor]="config().backgroundColor"
  >
    <img
      [alt]="config().picture.alternativeText"
      class="star-icon"
      [src]="config().picture.imageUrl"
    />

    <p
      class="earn-up-to"
      [style.color]="reward.color"
      [style.fontFamily]="reward.fontFamily"
    >
      @if (reward.stepText && spendGoal !== null) {
        {{
          reward.stepText
            | replaceVars: (spendGoal | formatAmount: 'currency' : 0)
        }}
      } @else {
        {{ reward.text }}
      }
      <span
        class="reward-value"
        [innerHTML]="maxReward() | formatReward | safe"
      ></span>
    </p>
  </div>
  <div class="button-container">
    <b2c-button
      [styles]="{
        fontSize: '12px',
        width: '250px',
        padding: '0.5rem 1rem',
        border: 'none',
        color: config().button.color,
        fontFamily: config().button.fontFamily,
        backgroundColor: config().button.backgroundColor,
      }"
      data-cy="select_btn"
      [title]="config().button.title"
      [loading]="selectionInProgress()"
      [attr.aria-label]="config().button.title"
      (click)="
        selectChallenge(
          challenge(),
          phase(),
          isBisCampaign(),
          isEventChallenge()
        )
      "
      [disabled]="
        challenge().isOutOfStock() ||
        selectionInProgress() ||
        blockSelectionButton()
      "
    >
      {{ config().button.text }}
    </b2c-button>
  </div>
</div>
